import { render, staticRenderFns } from "./HelpCenter2.vue?vue&type=template&id=8b42fb6e"
import script from "./HelpCenter2.vue?vue&type=script&lang=js"
export * from "./HelpCenter2.vue?vue&type=script&lang=js"
import style0 from "./HelpCenter2.vue?vue&type=style&index=0&id=8b42fb6e&prod&lang=scss&rel=stylesheet%2Fscss"
import style1 from "./HelpCenter2.vue?vue&type=style&index=1&id=8b42fb6e&prod&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports